import {
  Control,
  ControllerFieldState,
  ControllerRenderProps,
  SetValueConfig,
  UseFormStateReturn,
  useController,
  useFormContext
} from "react-hook-form";

export function useFormField<FieldValue>(name: string, controller?: Control) {
  const formContext = useFormContext();

  const { field, fieldState, formState } = useController({
    name,
    controller
  } as any) as {
    field: Omit<ControllerRenderProps, "value"> & {
      value: FieldValue;
    };
    fieldState: ControllerFieldState;
    formState: UseFormStateReturn<any>;
  };

  const setFieldValue = (value: FieldValue, options?: SetValueConfig) =>
    formContext.setValue(name, value, options);

  const resetField = () => formContext.resetField(name);

  return { setFieldValue, field, fieldState, formState, formContext, resetField };
}
